import React, { useState, useRef, useEffect } from 'react';
import CommonToast from '../../../Common_Components/CommonToast';

const VideoPreviewWindow = ({ activeVideo, veo2Videos }) => {
  const [currentVideo, setCurrentVideo] = useState(null);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [volume, setVolume] = useState(1);
  const videoRef = useRef(null);
   const [open, setOpen] = useState(false);
    const [content, setContent] = useState();
    const [iconType, setIconType] = useState("success");
  
    const handleCloseToast = () => {
      setOpen(false);
    };

    useEffect(()=>{
      if(veo2Videos){
        setCurrentVideo(veo2Videos[activeVideo])
      }
    },[activeVideo, veo2Videos])
  


  // Handle video end to play next video
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleEnded = () => {
      if (currentVideoIndex < veo2Videos?.length - 1) {
        setCurrentVideoIndex(prev => prev + 1);
      } else {
        setIsPlaying(false);
        setCurrentVideoIndex(0);
      }
    };

    const handleTimeUpdate = () => {
      if (video.duration) {
        setProgress((video.currentTime / video.duration) * 100);
      }
    };

    const handleLoadedMetadata = () => {
      setProgress(0);
    };

    video.addEventListener('ended', handleEnded);
    video.addEventListener('timeupdate', handleTimeUpdate);
    video.addEventListener('loadedmetadata', handleLoadedMetadata);

    return () => {
      video.removeEventListener('ended', handleEnded);
      video.removeEventListener('timeupdate', handleTimeUpdate);
      video.removeEventListener('loadedmetadata', handleLoadedMetadata);
    };
  }, [currentVideoIndex, veo2Videos?.length]);

  // Handle play/pause
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;


    if (isPlaying) {
      if(veo2Videos?.length == 0){
      setOpen(true);
      setIconType('error')
      setContent('Generate Video To Play Video')
      return
      } 
      video.play().catch(error => {
        console.error('Error playing video:', error);
        setIsPlaying(false);
      });
    } else {
      video.pause();
    }
  }, [isPlaying, currentVideoIndex]);

  // Play/Pause toggle
  const togglePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  // Play specific video
  const playVideo = (index) => {
    if (index === currentVideoIndex) {
      togglePlayPause();
    } else {
      setCurrentVideoIndex(index);
      setIsPlaying(true);
    }
  };

  // Previous video
  const playPrevious = () => {
    if (currentVideoIndex > 0) {
      setCurrentVideoIndex(prev => prev - 1);
      setIsPlaying(true);
    }
  };

  // Next video
  const playNext = () => {
    if (currentVideoIndex < veo2Videos?.length - 1) {
      setCurrentVideoIndex(prev => prev + 1);
      setIsPlaying(true);
    }
  };

  // Seek video
  const handleSeek = (e) => {
    const video = videoRef.current;
    if (!video || !video.duration) return;

    const seekTime = (e.target.value / 100) * video.duration;
    video.currentTime = seekTime;
    setProgress(e.target.value);
  };

  // Handle volume change
  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    if (videoRef.current) {
      videoRef.current.volume = newVolume;
    }
  };

  // Format time (seconds to MM:SS)
  const formatTime = (seconds) => {
    if (!seconds || isNaN(seconds)) return '0:00';
    
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // Get current time and duration
  const getCurrentTime = () => {
    const video = videoRef.current;
    return video ? video.currentTime : 0;
  };

  const getDuration = () => {
    const video = videoRef.current;
    return video ? video.duration : 0;
  };

  return (
    <div style={{
      width: '583px',
      borderRadius: '12px',
      padding: '16px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
      fontFamily: 'Arial, sans-serif',
      color: 'white',
      backgroundColor: '#282D51',
    }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '12px',
      }}>
        <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
          Video Preview
           {/* ({currentVideoIndex + 1}/{veo2Videos.length}) */}
        </h3>
      </div>

      {/* Main Video Player */}
      <div style={{
        position: 'relative',
        borderRadius: '8px',
        overflow: 'hidden',
        marginBottom: '12px',
        backgroundColor: '#282D51',
        display:"flex",
        flexDirection:"column",
        justifyContent:"center",
        alignItems:"center"
      }}>
        <video key={currentVideo?.url}
          ref={videoRef}
          src={currentVideo?.url}
          style={{
            width: "400px",
            height: '225px',
            objectFit: 'contain',
            backgroundColor: '#000'
          }}
          preload="metadata"
          onClick={togglePlayPause}
        />
        
        {/* Play/Pause overlay */}
        {!isPlaying && (
          <div
            onClick={togglePlayPause}
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '60px',
              height: '60px',
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
              <path d="M8 5v14l11-7z"/>
            </svg>
          </div>
        )}
      </div>

      {/* Progress Bar */}
      <div style={{ marginBottom: '12px' }}>
        <input
          type="range"
          min="0"
          max="100"
          value={progress}
          onChange={handleSeek}
          style={{
            width: '100%',
            height: '4px',
            borderRadius: '2px',
            backgroundColor: '#333',
            outline: 'none',
            cursor: 'pointer'
          }}
        />
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: '12px',
          color: '#ccc',
          marginTop: '4px'
        }}>
          <span>{formatTime(getCurrentTime())}</span>
          <span>{formatTime(getDuration())}</span>
        </div>
      </div>

      {/* Controls */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}>
        {/* Previous Button */}
        {/* <button
          onClick={playPrevious}
          disabled={currentVideoIndex === 0}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            color: currentVideoIndex === 0 ? '#666' : 'white',
            cursor: currentVideoIndex === 0 ? 'not-allowed' : 'pointer',
            padding: '8px',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M6 6h2v12H6zm3.5 6l8.5 6V6z"/>
          </svg>
        </button> */}

        {/* Play/Pause Button */}
        {/* <button
          onClick={togglePlayPause}
          style={{
            backgroundColor: '#007bff',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            padding: '10px',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease'
          }}
        >
          {isPlaying ? (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
            </svg>
          ) : (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M8 5v14l11-7z"/>
            </svg>
          )}
        </button> */}

        {/* Next Button */}
        {/* <button
          onClick={playNext}
          disabled={currentVideoIndex === veo2Videos.length - 1}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            color: currentVideoIndex === veo2Videos.length - 1 ? '#666' : 'white',
            cursor: currentVideoIndex === veo2Videos.length - 1 ? 'not-allowed' : 'pointer',
            padding: '8px',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"/>
          </svg>
        </button> */}

        {/* Volume Control */}
        {/* <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          marginLeft: 'auto'
        }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#ccc">
            <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
          </svg>
          <input
            type="range"
            min="0"
            max="1"
            step="0.1"
            value={volume}
            onChange={handleVolumeChange}
            style={{
              width: '80px',
              height: '4px',
              borderRadius: '2px',
              backgroundColor: '#333',
              outline: 'none',
              cursor: 'pointer'
            }}
          />
        </div> */}
      </div>

      {/* Video Info */}
      {/* <div style={{
        marginTop: '12px',
        padding: '8px',
        backgroundColor: '#2a2a2a',
        borderRadius: '6px',
        fontSize: '12px'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>Current Video:</span>
          <span style={{ color: '#007bff' }}>Video {currentVideoIndex + 1}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px' }}>
          <span>Status:</span>
          <span style={{ color: isPlaying ? '#28a745' : '#ffc107' }}>
            {isPlaying ? 'Playing' : 'Paused'}
          </span>
        </div>
      </div> */}

      {/* CSS for pulse animation */}
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.5; }
            100% { opacity: 1; }
          }
          
          input[type="range"]::-webkit-slider-thumb {
            -webkit-appearance: none;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #007bff;
            cursor: pointer;
          }
          
          input[type="range"]::-moz-range-thumb {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #007bff;
            cursor: pointer;
            border: none;
          }
        `}
      </style>
      <CommonToast
              open={open}
              onClose={handleCloseToast}
              content={content}
              iconType={iconType}
              bgColor={"#373E6D"}
            />
    </div>
  );
};

export default VideoPreviewWindow;